<template>
  <div class="column content-box">
    <woot-loading-state
      v-if="uiFlags.isFetchingReport"
      message="Carregando relatório"
    />

    <div v-else>
      <h4>Relatório da ação massiva #{{ bulkActionId }}</h4>

      <p><strong>Total:</strong> {{ summary.total }}</p>
      <p><strong>Processadas:</strong> {{ summary.processed }}</p>
      <p><strong>Falhas:</strong> {{ summary.failed }}</p>
      <p>
        <strong>Duração (s):</strong>
        {{ summary.duration_seconds || '-' }}
      </p>

      <div v-if="reportErrors.length">
        <h5>Erros</h5>
        <ul>
          <li v-for="(error, index) in reportErrors" :key="index">
            {{ error.message || error }}
          </li>
        </ul>
      </div>

      <div v-else>
        <p>Nenhum erro registrado.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  computed: {
    ...mapGetters({
      report: 'bulkActionsSettings/getReport',
      uiFlags: 'bulkActionsSettings/getUIFlags',
    }),
    bulkActionId() {
      return this.$route.params.bulkActionId;
    },
    summary() {
      const reportPayload = this.report?.report || this.report || {};

      return {
        total: reportPayload.total || reportPayload.total_count || 0,
        processed:
          reportPayload.processed || reportPayload.processed_count || 0,
        failed: reportPayload.failed || reportPayload.failed_count || 0,
        duration_seconds: reportPayload.duration_seconds,
      };
    },
    reportErrors() {
      const reportPayload = this.report?.report || this.report || {};
      return reportPayload.errors || [];
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch(
        'bulkActionsSettings/getReport',
        this.bulkActionId
      );
    } catch (error) {
      this.showAlert('Não foi possível carregar o relatório.');
    }
  },
  beforeDestroy() {
    this.$store.dispatch('bulkActionsSettings/clearReport');
  },
};
</script>
